import IAjaxConnect from "./IAjaxConnect";
import {FETCH_TYPES, getFormData, parseURL} from "../Connect";
import SystemConfig, {CONFIG_PARAMS} from "../../system/SystemConfig";
import {inject} from "inversify";
import SERVICE_IDENTIFIER from "../../constants/identifiers";

export default class ConnectCloseBeacon implements IAjaxConnect {

    public readonly fetchType: string = FETCH_TYPES.CLOSE;
    timeout: number = 0;

    private config: SystemConfig;

    private data: Record<string, any>;

    constructor(
        @inject(SERVICE_IDENTIFIER.SystemConfig) config: SystemConfig,
    ) {

        this.config = config;
    }

    async fetch(data) {
        this.data = data;
        console.log("close beacon");
        navigator.sendBeacon(this.getUrl(), getFormData(this.getParams()));
    }

    getParams() {
        return {
            session_id: this.data.sessionId,
            casino_id: this.data.casinoId,
            ended: "true"
        };
    }

    getUrl() {
        return parseURL(this.config.get(CONFIG_PARAMS.URL_CLOSE), {
            "server_api": this.data.serverApi,
            "session_id": this.data.sessionId,
            "casino_id": this.data.casinoId
        });
    }
}